module.exports = __webpack_public_path__ + "static/media/25587213_1703511443057373_7936410502981653430_o.b3801654.jpg";